<template>
    <div>
        <div class="flex justify-end mb-4 px-4 ">
            <SearchInput @search-select="onDealerSelected" @clear="onClearSearch" />
        </div>
        <div
            class="overflow-hidden rounded-md border border-light-border dark:border-dark-border bg-primary-bg text-primary-text dark:text-gray-100 dark:bg-primary-dark-bg  pb-3 shadow-md">
            <div class="w-full overflow-x-auto">
                <table class="min-w-full text-left text-sm text-secondary-text dark:text-gray-300">
                    <thead class=" bg-gray-100 dark:bg-gray-800 font-medium">
                        <tr>
                            <th class="px-2 md:px-4 py-2 md:py-4">Sipariş No</th>
                            <th class="px-2 md:px-4 py-2 md:py-4">Bayi</th>
                            <th class="px-2 md:px-4 py-2 md:py-4">Ürün</th>
                            <th class="px-2 md:px-4 py-2 md:py-4">Miktar</th>
                            <th class="px-2 md:px-4 py-2 md:py-4">Plaka</th>
                            <th class="px-2 md:px-4 py-2 md:py-4">Durum</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="order in approvedOrders" :key="order.id" class="border-b">
                            <td class="px-2 md:px-4 py-2 md:py-4">{{ order.orderNumber }}</td>
                            <td class="px-2 md:px-4 py-2 md:py-4">{{ order.dealerName }}</td>
                            <td class="px-2 md:px-4 py-2 md:py-4">{{ order.productName }}</td>
                            <td class="px-2 md:px-4 py-2 md:py-4">{{ order.deliveredTonnage }}</td>
                            <td class="px-2 md:px-4 py-2 md:py-4">{{ order.vehiclePlate }}</td>
                            <td class="px-2 md:px-4 py-2 md:py-4 text-green-700 font-medium">
                                <span class="px-3 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-800">
                                    Onaylandı
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <AppPagination :currentPage="currentPage" :totalPages="totalPages" @prev-page="currentPage--"
                @next-page="currentPage++" @go-to-page="page => currentPage = page" />
        </div>
    </div>
</template>

<script>
import { getApi } from '@/services/api';
import SearchInput from '@/components/SearchInput.vue'
import AppPagination from '@/components/AppPagination.vue';

export default {
    name: 'ApprovedDeliveries',
    components: {
        SearchInput,
        AppPagination
    },
    data() {
        return {
            approvedOrders: [],
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
            selectedDealerId: null,
        };
    },
    computed: {
        totalPages() {
            return Math.ceil(this.totalResult / this.pageSize);
        }
    },
    methods: {
        // async fetchApprovedDeliveries() {
        //     const take = this.pageSize;
        //     const skip = (this.currentPage - 1) * take;

        //     let url = `/deliveries/${take}/${skip}`;
        //     if (this.selectedDealerId) {
        //         url = `/deliveries/by_dealer/${this.selectedDealerId}/${take}/${skip}`;
        //     }

        //     const response = await getApi(url);
        //     const deliveries = response.deliveries || [];
        //     this.totalResult = response.total_result || 0;

        //     const approvedDeliveries = deliveries.filter(d => d.is_approved === 1);
        //     const detailedPromises = approvedDeliveries.map(d =>
        //         getApi(`/deliveries/${d.delivery_id}`).catch(() => null)
        //     );

        //     const detailedResults = await Promise.all(detailedPromises);

        //     this.approvedOrders = approvedDeliveries.map((d, i) => {
        //         const detail = detailedResults[i];
        //         return {
        //             id: d.delivery_id,
        //             orderNumber: detail?.order?.order_number || '-',
        //             dealerName: detail?.order?.dealer?.dealer_name || 'Bayi',
        //             productName: detail?.order?.ordered_products?.map(p => p.product?.name).join(', ') || 'Ürün',
        //             deliveredTonnage: d.delivery_tonnage,
        //             vehiclePlate: d.delivery_plate || '-'
        //         };
        //     });
        // },

        async fetchApprovedDeliveries() {
            const take = this.pageSize;
            const skip = (this.currentPage - 1) * take;

            let url = `/deliveries/approved/${take}/${skip}`;
            if (this.selectedDealerId) {
                url = `/deliveries/by_dealer/${this.selectedDealerId}/${take}/${skip}`;
            }

            const response = await getApi(url);
            const deliveries = response.deliveries || [];

            this.totalResult = response.total_result || 0;

            const detailedPromises = deliveries.map(d =>
                getApi(`/deliveries/${d.delivery_id}`).catch(() => null)
            );
            const detailedResults = await Promise.all(detailedPromises);

            this.approvedOrders = deliveries.map((d, i) => {
                const detail = detailedResults[i];
                return {
                    id: d.delivery_id,
                    orderNumber: detail?.order?.order_number || '-',
                    dealerName: detail?.order?.dealer?.dealer_name || 'Bayi',
                    productName: detail?.order?.ordered_products?.map(p => p.product?.name).join(', ') || 'Ürün',
                    deliveredTonnage: d.delivery_tonnage,
                    vehiclePlate: d.delivery_plate || '-'
                };
            });
        },

        async onDealerSelected(dealer) {
            this.selectedDealerId = dealer.dealer_id;
            this.currentPage = 1;
            await this.fetchApprovedDeliveries();
        },

        async onClearSearch() {
            this.selectedDealerId = null;
            this.currentPage = 1;
            await this.fetchApprovedDeliveries();
        }
    },
    watch: {
        currentPage() {
            this.fetchApprovedDeliveries();
        }
    },
    mounted() {
        this.fetchApprovedDeliveries();
    }
};
</script>
